import React, { useState } from "react";
import { Typography, TextField, Button } from "@mui/material";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../ui/tabs";

// Actions
import { updateMacroEventServings } from "../../../actions/insights";

const MacrosItem = ({ data, servings = 1 }) => {
  const amount = servings === 1 ? data.amount : data.amount * servings;

  return (
    <div>
      <div className="flex flex-row justify-between items-center">
        <Typography variant="subtitle1" className="font-normal leading-snug">
          {data.name}
        </Typography>
        <div className="flex-1 border-b border-separator mx-2"></div>
        <div className="flex flex-row">
          <Typography variant="body2">{amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2)}</Typography>
          {data.unit && (
            <Typography variant="body2" className="ml-1">
              {data.unit.name}
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
};

const EditHistoryMacros = ({
  historyIndex,
  macroSectionIndex,
  insights: { recipeHistory, servingsUpdateLoading },
  handleClose,
  updateMacroEventServings,
}) => {
  const section = recipeHistory[historyIndex].macros.sections[macroSectionIndex];
  const eventId = recipeHistory[historyIndex].macros.id;
  const [localServingsEaten, setLocalServingsEaten] = useState(section?.servingsEaten || 0);
  const [activeTab, setActiveTab] = useState("total");

  const handleServingsChange = (e) => {
    const value = e.target.value;
    if (value === "" || isNaN(value)) {
      setLocalServingsEaten("");
      return;
    }

    const numValue = parseFloat(value);
    if (numValue < 0) {
      setLocalServingsEaten("");
      return;
    }

    // Limit to 2 decimal places
    setLocalServingsEaten(Math.round(numValue * 100) / 100);
  };

  const handleSave = async () => {
    const success = await updateMacroEventServings(eventId, historyIndex, macroSectionIndex, localServingsEaten);

    if (success) {
      handleClose();
    }
  };

  return (
    <div className="w-full max-w-full md:max-w-[600px]">
      {section?.name && section?.name !== "" && (
        <div className="w-full p-4 bg-neutral-100">
          <Typography variant="h6" className="font-normal">
            {section?.name}
          </Typography>
        </div>
      )}

      <div className="p-4">
        <div className="mb-4 pt-2">
          <TextField
            label="Servings Eaten"
            value={localServingsEaten}
            onChange={handleServingsChange}
            type="number"
            inputProps={{
              min: "0",
              max: 100,
            }}
            fullWidth
          />
        </div>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="w-full mb-4">
            <TabsTrigger value="total" className="flex-1">
              Total Macros
            </TabsTrigger>
            <TabsTrigger value="single" className="flex-1">
              Per Serving
            </TabsTrigger>
          </TabsList>

          <TabsContent value="total">
            <div>
              {section?.macros &&
                section.macros.map((macro, index) => (
                  <MacrosItem key={index} data={macro} servings={localServingsEaten} />
                ))}
            </div>
          </TabsContent>

          <TabsContent value="single">
            <div>
              {section?.macros &&
                section.macros.map((macro, index) => <MacrosItem key={index} data={macro} servings={1} />)}
            </div>
          </TabsContent>
        </Tabs>

        <div className="mt-4 w-full">
          <Button
            onClick={() => handleSave()}
            variant="contained"
            color="primary"
            disableElevation
            disableRipple
            fullWidth
            disabled={servingsUpdateLoading}
          >
            {servingsUpdateLoading ? "Saving..." : "Save"}
          </Button>
        </div>
      </div>
    </div>
  );
};

EditHistoryMacros.propTypes = {
  historyIndex: PropTypes.number.isRequired,
  macroSectionIndex: PropTypes.number.isRequired,
  insights: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  updateMacroEventServings: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  insights: state.insights,
});

export default connect(mapStateToProps, { updateMacroEventServings })(EditHistoryMacros);
